import { DataManager } from '@/app/editor/iframe/atom/service/DataManager';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';
import BaseSettingHandler from './BaseSettingHandler';
import pImageInfo from '@/app/editor/sidebar/module/pImage';
const USING_SELF = 1;

/**
 * AtomTargetHandler
 */
export abstract class AtomTargetHandler extends BaseSettingHandler {
  $el: JQuery;
  atomModel: AtomModel;
  /**
   * get $target for read and write
   * @param typeHandel :string
   * @param _this : this
   * @returns $target
   */
  getAtomTarget(typeHandel: string, _this: any): JQuery {
    const $atom: JQuery = DataManager.getAtomDomById(_this.getAtomModel().id) || this.get$el();
    let $self: JQuery = $atom;
    if (_this.setting.selfSelector) {
      const selfSelector: string = _this.setting.selfSelector;
      let isUsingSelf: any;
      if (typeHandel == 'read') {
        isUsingSelf = selfSelector.split(',')[0];
      } else if (typeHandel == 'write') {
        isUsingSelf = selfSelector.split(',')[1];
      }
      if (isUsingSelf == USING_SELF) {
        const moduleClass = _this.setting.targetSelector;
        if (moduleClass != '') {
          return ($self = $atom.find(moduleClass));
        }
      }
    }
    return $self;
  }

  /**
   * getTargetClass
   * @returns Class name of module
   */
  getTargetClassSelector(): string {
    return '.' + pImageInfo.class;
  }
  /**
   * get$el
   * @param _this _this
   */
  get$el(): JQuery {
    return this.$el;
  }

  /**
   * set$el
   * @param $el $el
   */
  set$el($el: JQuery) {
    this.$el = $el;
  }

  /**
   * set$el
   * @param $el $el
   */
  setAtomModel(atomModel: AtomModel) {
    this.atomModel = atomModel;
  }
}
